import { render, staticRenderFns } from "./advice-list.vue?vue&type=template&id=32ed53c8&scoped=true&"
import script from "./advice-list.vue?vue&type=script&lang=js&"
export * from "./advice-list.vue?vue&type=script&lang=js&"
import style0 from "./advice-list.vue?vue&type=style&index=0&id=32ed53c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ed53c8",
  null
  
)

export default component.exports